import { render, staticRenderFns } from "./CourseDetailsIndividual.vue?vue&type=template&id=0b74b784&scoped=true&"
import script from "./CourseDetailsIndividual.vue?vue&type=script&lang=js&"
export * from "./CourseDetailsIndividual.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetailsIndividual.vue?vue&type=style&index=0&id=0b74b784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b74b784",
  null
  
)

export default component.exports